import type { Components, Theme } from "@mui/material";

export const avatarTheme: Components<Theme>["MuiAvatar"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: "48px",
      height: "48px",
      border: "none",
      borderRadius: "20px",
      outlineOffset: "-1px",
      outline: `1px solid ${theme.palette.custom.borderSecondary}`,
    }),
    colorDefault: ({ theme }) => ({
      color: theme.palette.text.main,
      backgroundColor: theme.palette.custom.surfaceTertiary,
    }),
  },
};
